export default "__VITE_ASSET__C36Q3QiQ__"